const map = new Map();
export const abortController = (key) => {
    map.get(key)?.abort()
    const controller = new AbortController()
    map.set(key, controller)
    return controller.signal
}
export const ABORTED = 'AbortError';
export const errorCustomizer = (thunkAPI, e) => thunkAPI.rejectWithValue(e.name === ABORTED ? ABORTED : e.response.data)